import { render, staticRenderFns } from "./ConfirmAtivarDeleteDoencaModal.vue?vue&type=template&id=43d177bd&"
import script from "./ConfirmAtivarDeleteDoencaModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAtivarDeleteDoencaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports